<div
  class="sidenav"
  [class.sidenav-collapsed]="collapsed">
  <div class="sidenav-header">
    @if (!collapsed) {
      <a class="sidenav-home-link" routerLink="/" aria-label="Go to the AZone homepage">
        <img class="sidenav-wordmark" src="assets/img/azone-wordmark.svg" alt="AZone" />
      </a>
    }
    <button
      class="sidenav-toggle-btn"
      type="button"
      (click)="toggleCollapse()"
      [attr.aria-expanded]="!collapsed"
      [attr.aria-label]="collapsed ? 'Expand admin navigation' : 'Collapse admin navigation'">
      <i
        class="fas sidenav-toggle-icon"
        [ngClass]="collapsed ? 'fa-chevron-right' : 'fa-chevron-left'"
        aria-hidden="true"></i>
    </button>
  </div>

  <ul class="sidenav-nav">
    @for (data of navData; track data.routerLink) {
      <li class="sidenav-nav-item">
        <a
          class="sidenav-nav-link"
          [routerLink]="data.routerLink"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="hightlight"
          (click)="onNavLinkClick()"
          [attr.title]="collapsed ? (data.label | translate | async) : null">
          <i class="sidenav-link-icon" [class]="data.icon" aria-hidden="true"></i>
          @if (!collapsed) {
            <span class="sidenav-link-text" @fadeInOut>{{
              data.label | translate | async
            }}</span>
          }
          @if (!collapsed && data.children?.length) {
            <button
              class="submenu-toggle"
              type="button"
              (click)="toggleSubMenu(data.label, $event)">
              <i class="fal" [class.fa-chevron-down]="!isSubMenuOpen(data.label)" [class.fa-chevron-up]="isSubMenuOpen(data.label)"></i>
            </button>
          }
        </a>

        @if (!collapsed && data.children?.length && isSubMenuOpen(data.label)) {
          <ul class="submenu-list" @fadeInOut>
            @for (child of data.children; track child.routerLink) {
              <li class="submenu-item">
                <a
                  class="submenu-link"
                  [routerLink]="child.routerLink"
                  [routerLinkActiveOptions]="{ exact: true }"
                  routerLinkActive="hightlight"
                  (click)="onNavLinkClick()">
                  {{ child.label | translate | async }}
                </a>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>

  <div class="sidenav-footer">
    <ul class="logout-nav">
      <li class="logout-nav-item cursor-pointer" (click)="getLogOut()">
        <button
          type="button"
          class="logout-nav-link ps-[3px]"
          [attr.title]="collapsed ? ('admin.logout' | translate | async) : null">
          <label class="rotate cursor-pointer">
            <i class="fas fa-sign-out-alt text-[35px] ms-1"></i
            ></label>
            @if (!collapsed) {
              <span class="logout-link-text ms-2" @fadeInOut>
                {{ 'admin.logout' | translate | async }}
              </span>
            }
          </button>
        </li>
      </ul>
    </div>
  </div>
